import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExportLog } from '../models/export-log.model';
import { ExportSdk } from '../sdks/export.sdk';

@Injectable({
	providedIn: 'root'
})
export class ExportLogService {

	constructor(private exportSdk: ExportSdk) { }

	exportLog(payload: ExportLog): Observable<any> {
		return this.exportSdk.exportLog(payload);
	}
}
